export default __webpack_public_path__ + "static/media/profile.9f45e901.jpg";